import ErrorIcon from 'src/resources/icons/error.svg'
import { FlexContainer } from 'src/applications/Embed/elements/SceneElements'
import { useTranslation } from 'react-i18next'

// TODO: replace with designs from Robert
export function ErrorScene() {
  const { t } = useTranslation()
  return (
    <FlexContainer>
      <img style={{ marginBottom: 6, width: 84 }} src={ErrorIcon} />
      {t('scenes.6_ErrorScene.importError')}
    </FlexContainer>
  )
}
